import * as React from 'react';
import type { TripStopType } from 'contracts/transport-routes';
import { useTranslation } from 'hooks';
import { RadioGroup, RadioGroupItem } from 'components/ui/radio-group';
import { Label } from 'components/ui/label';

import { translations } from './translations';

type Props = {
  defaultValue: TripStopType;
  onChange?: (value: TripStopType) => void;
}

export const TripStopTypeSelector = ({
                                       defaultValue,
                                       onChange,
                                     }: Props) => {
  const { getTranslation: t } = useTranslation(translations);

  const uniqueId = React.useId();

  const cityId = `${uniqueId}-city`;
  const coordinatesId = `${uniqueId}-coordinates`;

  return (
    <RadioGroup
      defaultValue={defaultValue}
      onValueChange={onChange}
      className={'flex flex-row gap-4'}
    >
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="city" id={cityId} />
        <Label htmlFor={cityId}>{t('cityStopType')}</Label>
      </div>
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="coordinates" id={coordinatesId} />
        <Label htmlFor={coordinatesId}>{t('coordinatesStopType')}</Label>
      </div>
    </RadioGroup>
  );
};